class Multicast {
  constructor() {
    this.init = false
  }
  _init = async () => {
    if (this.init) return true

    document.getElementById("player").appendChild(document.getElementById("videoplane"))
    document.getElementById("videoplane").style.backgroundImage = "url(tv:)"

    this.init = true

    return true
  }

  start = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    hcap.Media.shutDown({
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
  destroy = async forceDestroy => {
    if (__.media.isPlaying() || forceDestroy) await this.stop()

    return true
  }
  play = async () => {
    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    this.closeSubtitle()

    let requestObject = __.media.getSource()

    if (__.media.type !== "RF") requestObject = requestMulticast(requestObject)
    else requestObject = requestDVB(requestObject)

    /* Library Code */
    hcap.channel.requestChangeCurrentChannel({ ...requestObject, onSuccess: () => {}, onFailure: payload => promise.reject(payload.errorMessage) })
    /* Library Code */

    _$.vue.$once(["mediaPlaying", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    return promise.done
  }
  stop = async () => {
    let promise = await _$.progress.create(_$.progress.type.STOP)

    /* Library Code */
    hcap.channel.stopCurrentChannel({
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    let res = await promise.done

    if (res) {
      promise = await _$.progress.create()

      _$.vue.$once(["mediaStopped", "mediaError"], e => {
        e.type === "mediaError" ? promise.reject() : promise.resolve()
      })

      await _$.sleep(500)
      _$.handler.emit("media_event_received", "play_stop")

      res = await promise.done
    }
    return res
  }
  pause = async () => {
    return false
  }
  continue = async () => {
    return false
  }

  /* Control Helpers */
  isSeekable = async () => {
    return false
  }
  getDuration = async () => {
    return false
  }
  getPosition = async () => {
    return false
  }
  setPosition = async () => {
    return false
  }

  /* Language and Subtitles Helpers */
  getSubtitles = async () => {
    let promise = await _$.progress.create()

    /* Library Code */
    hcap.channel.getCurrentChannelSubtitleList({
      onSuccess: payload => promise.resolve(payload.list),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    let subtitles = await promise.done
    if (!subtitles) return false

    promise = await _$.progress.create()

    /* Library Code */
    hcap.channel.getCurrentChannelSubtitleIndex({
      onSuccess: payload => promise.resolve(payload.index.toString()),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    let current = await promise.done
    if (!current) return false

    subtitles = subtitles.split(",").map((subtitle, index) => {
      return { key: index.toString(), value: subtitle === "off" ? "None" : subtitle, selected: current == index }
    })

    if (subtitles.length <= 1) return false

    return subtitles
  }
  setSubtitle = async pid => {
    const promise = await _$.progress.create()

    /* Library Code */
    hcap.channel.setCurrentChannelSubtitleIndex({
      index: parseInt(pid),
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
  closeSubtitle = async () => {
    return this.setSubtitle(0)
  }

  getLanguages = async () => {
    let promise = await _$.progress.create()

    /* Library Code */
    hcap.channel.getCurrentChannelAudioLanguageList({
      onSuccess: payload => promise.resolve(payload.list),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    let languages = await promise.done
    if (!languages) return false

    promise = await _$.progress.create()

    /* Library Code */
    hcap.channel.getCurrentChannelAudioLanguageIndex({
      onSuccess: payload => promise.resolve(payload.index.toString()),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    let current = await promise.done
    if (!current) return false

    languages = languages.split(",").map((language, index) => {
      return { key: index.toString(), value: language, selected: current == index }
    })

    if (languages.length <= 1) return false
    return languages
  }
  setLanguage = async pid => {
    const promise = await _$.progress.create()

    /* Library Code */
    hcap.channel.setCurrentChannelAudioLanguageIndex({
      index: parseInt(pid),
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
}

const requestMulticast = requestObject => {
  const uri = _$.splitUrl(requestObject)
  uri.protocol = hcap.channel.IpBroadcastType[uri.protocol.toUpperCase()]
  return {
    channelType: hcap.channel.ChannelType.IP,
    ip: uri.host,
    port: parseInt(uri.port),
    ipBroadcastType: uri.protocol
  }
}
const requestDVB = requestObject => {
  const uri = __.media._convertDVB(requestObject)

  switch (uri.broadcastType) {
    case "DVBC":
      return {
        channelType: hcap.channel.ChannelType.RF,
        frequency: parseFloat(uri.frequency) * 1000000,
        programNumber: parseInt(uri.programNumber),
        symbolRate: parseInt(uri.symbolRate),
        rfBroadcastType: hcap.channel.RfBroadcastType.CABLE
      }
    case "DVBT":
      return {
        channelType: hcap.channel.ChannelType.RF,
        frequency: parseFloat(uri.frequency) * 1000000,
        programNumber: parseInt(uri.programNumber),
        rfBroadcastType: hcap.channel.RfBroadcastType.TERRESTRIAL
      }
    case "DVBS":
      return {
        channelType: hcap.channel.ChannelType.RF,
        frequency: parseFloat(uri.frequency),
        programNumber: parseInt(uri.programNumber),
        satelliteId: parseInt(uri.satelliteID),
        polarization: uri.polarization === "H" ? hcap.channel.Polarization.HORIZONTAL : hcap.channel.Polarization.VERTICAL,
        symbolRate: parseInt(uri.symbolRate),
        rfBroadcastType: hcap.channel.RfBroadcastType.SATELLITE
      }
    case "DVBS2":
      return {
        channelType: hcap.channel.ChannelType.RF,
        frequency: parseFloat(uri.frequency),
        programNumber: parseInt(uri.programNumber),
        satelliteId: parseInt(uri.satelliteID),
        polarization: uri.polarization === "H" ? hcap.channel.Polarization.HORIZONTAL : hcap.channel.Polarization.VERTICAL,
        symbolRate: parseInt(uri.symbolRate),
        rfBroadcastType: hcap.channel.RfBroadcastType.SATELLITE_2
      }
    case "ANALOG":
      return {
        channelType: hcap.channel.ChannelType.RF,
        frequency: parseFloat(uri.frequency) * 1000000,
        programNumber: 0,
        rfBroadcastType: hcap.channel.RfBroadcastType.ANALOG_PAL_BG
      }
  }
}

export default Multicast
